/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/house_value'
export default icon
